import moment from "moment";
import {
  GET_EXCHANGE_RATE,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialLanguage = {
  exchangeRate: [],
  exchangeRateCount: 0,
  page: 1,
  search: "",
};

const languageReducer = (state = initialLanguage, action) => {
  switch (action.type) {
    case GET_EXCHANGE_RATE:
      return {
        ...state,
        exchangeRate: action.payload.exchangeRates.map((rate) => {
          return {
            ...rate,

            updatedAtFormatted: moment(rate.updatedAt).format("ll"),
          };
        }),
        exchangeRateCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default languageReducer;
